<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="width"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      opacity="0.3"
      d="M14.2934 16.7064C14.1112 16.5178 14.0105 16.2652 14.0127 16.003C14.015 15.7408 14.1202 15.49 14.3056 15.3046C14.491 15.1192 14.7418 15.014 15.004 15.0118C15.2662 15.0095 15.5188 15.1103 15.7074 15.2924L19.7074 19.2924C19.8896 19.481 19.9904 19.7336 19.9881 19.9958C19.9858 20.258 19.8806 20.5088 19.6952 20.6942C19.5098 20.8797 19.259 20.9848 18.9968 20.9871C18.7346 20.9894 18.482 20.8886 18.2934 20.7064L14.2934 16.7064Z"
      :fill="color"
    />
    <path
      d="M11 16C11.9889 16 12.9556 15.7068 13.7779 15.1574C14.6001 14.6079 15.241 13.8271 15.6194 12.9134C15.9978 11.9998 16.0969 10.9945 15.9039 10.0246C15.711 9.05465 15.2348 8.16373 14.5355 7.46447C13.8363 6.76521 12.9454 6.289 11.9755 6.09608C11.0055 5.90315 10.0002 6.00217 9.08659 6.38061C8.17296 6.75904 7.39206 7.39991 6.84266 8.22215C6.29325 9.0444 6 10.0111 6 11C6 12.3261 6.52679 13.5979 7.46447 14.5355C8.40215 15.4732 9.67392 16 11 16ZM11 18C9.61553 18 8.26216 17.5895 7.11101 16.8203C5.95987 16.0511 5.06266 14.9579 4.53285 13.6788C4.00303 12.3997 3.86441 10.9922 4.13451 9.63437C4.4046 8.2765 5.07129 7.02922 6.05026 6.05026C7.02922 5.07129 8.2765 4.4046 9.63437 4.13451C10.9922 3.86441 12.3997 4.00303 13.6788 4.53285C14.9579 5.06266 16.0511 5.95987 16.8203 7.11101C17.5895 8.26216 18 9.61553 18 11C18 12.8565 17.2625 14.637 15.9497 15.9497C14.637 17.2625 12.8565 18 11 18Z"
      :fill="color"
    />
  </svg>
</template>
<script setup lang="ts">
import { type CbIconProps, cbIconDefaults } from "../cb-icon.props";

withDefaults(defineProps<CbIconProps>(), cbIconDefaults);
</script>
